import React from 'react';
import Divider from './Divider';

export type FormSectionHeadingLevel = 2 | 3 | 4 | 5 | 6;

export interface FormSectionHeadingProps {
    children: React.ReactNode;
    /** The rule that runs from the label to the edge of the section. */
    rule?: boolean;
    /** Where the section sits in the page's heading hierarchy. */
    level?: FormSectionHeadingLevel;
    className?: string;
    style?: React.CSSProperties;
}

/**
 * Names a group of fields in a form and rules off the space beside it. Quieter than
 * `Typography.FormSectionTitle`, which titles a form rather than dividing one.
 */
export const FormSectionHeading: React.FC<FormSectionHeadingProps> = ({
    children,
    rule = true,
    level = 3,
    className = '',
    style = {},
}) => {
    const HeadingTag: `h${FormSectionHeadingLevel}` = `h${level}`;

    return (
        <div className={`flex items-center gap-2 w-full px-2 ${className}`.trim()} style={style}>
            <HeadingTag className="m-0 whitespace-nowrap shrink-0 text-[length:var(--malachite-font-size-small,13px)] font-normal leading-[1.6] text-[var(--malachite-text-secondary,rgb(123,123,123))]">
                {children}
            </HeadingTag>
            {rule && (
                <div className="flex-auto min-w-0">
                    <Divider />
                </div>
            )}
        </div>
    );
};

export default FormSectionHeading;
